export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11080.4bf3a103.jpg";